import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { GetIcon } from "../icons/GetIcon.js";

export default class SortToggle extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClick(value) {
    const { handleUpdate } = this.props;

    handleUpdate({ "sortBy": value });
  }

  renderSortOption = (sorter, i) => {
    const { sortBy, sorters } = this.props;
    const active = sortBy === sorter.value || sorter.isActive && !sortBy;

    const buttonClass = classNames("btn btn--link", {
      "is-active": active
    });

    const divider = i + 1 < sorters.length ? " / " : "";

    return ( <span key={ i }><button onClick={() => this.handleClick(sorter.value)} className={ buttonClass }>{ sorter.label }{active && (<span className="visually-hidden">selected</span>)}</button>{ divider }</span>);
  }

  render() {
    const { sorters, sortLabel } = this.props;

    return (
      <div className="search__info-sort" aria-live="polite">
        { sortLabel ? sortLabel : "Sort by" }{ ": " }
        { sorters.length > 0 && sorters.map((sorter, i) => {
          return this.renderSortOption(sorter, i);
        }) }
      </div>
    );
  }
}

const { array, func, string } = PropTypes;

SortToggle.propTypes= {
  handleUpdate: func,
  sortBy: string,
  sorters: array.isRequired,
  sortLabel: string
};
